<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { ServiceCategoryEntity } from '../../../modules/posApi/service-categories/service-category.entity'
    import type { CreateServiceCategoryDto } from '../../../modules/posApi/service-categories/dto/create-service-category.dto'
    import type { UpdateServiceCategoryDto } from '../../../modules/posApi/service-categories/dto/update-service-category.dto'
    const dispatch = createEventDispatcher()

    function sendClose() {
        dispatch('close')
    }

    export let serviceCategoryId = null
    export let form: boolean = false

    let show = false
    let step = 1
    let entities: ServiceCategoryEntity[] = []
    let entity: ServiceCategoryEntity = new ServiceCategoryEntity()

    async function editEntity(id: string) {
        try {
            show = true
            entity = new ServiceCategoryEntity()
            entity = await window.api.pos.serviceCategories.getOne(id)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new ServiceCategoryEntity()
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreateServiceCategoryDto = {
                name: entity.name,
                color: entity.color,
            }
            entity = await window.api.pos.serviceCategories.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateServiceCategoryDto = {
                name: entity.name,
                color: entity.color,
            }
            await window.api.pos.serviceCategories.update(entity.serviceCategoryId, dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity.serviceCategoryId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.pos.serviceCategories.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Categorias de Serviços'
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.cols.push(new GridCol({ content: 'Nome da categoria', type: GridColTypeEnum.string, maxLength: 150 }))
        grid.cols.push(new GridCol({ content: 'Data de criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnEdit = new GridButton({
                callback: () => editEntity(item.serviceCategoryId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.name })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.pos.serviceCategories.remove(entity.serviceCategoryId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (serviceCategoryId) {
                await editEntity(serviceCategoryId)
            } else {
                newEntity()
            }
        }
    })
</script>

{#if step === 1}
    <Content footer={true}>
        <Zact>
            <div class="spacer" />
            <Zbutton color="primary" icon={faPlusCircle} label="Nova categoria" mobileHideLabel={true} on:click={newEntity} />
        </Zact>
        <Zgrid class="h-space" {grid} />
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content footer={true}>
        <Zact>
            {#if !form}
                <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            {/if}
            <div class="spacer" />
            {#if !!entity?.serviceCategoryId}
                <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
            {/if}
            <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
        </Zact>

        <Zframe title="Categoria" class="h-space">
            <ZContainer>
                <Zinput size={4} sizeM={12} label="Nome da categoria" bind:value={entity.name} />
                <Zinput size={4} sizeM={12} label="Cor" type="palette" palette="pastel" bind:value={entity.color} />
            </ZContainer>
        </Zframe>
        <LoadSpinner {show} />
    </Content>
{/if}
